import { render, staticRenderFns } from "./SkillboxInput.vue?vue&type=template&id=2b116eb0&"
import script from "./SkillboxInput.vue?vue&type=script&lang=js&"
export * from "./SkillboxInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports